
// apply_status:申请状态(1等待审核、2审核后被驳回、3审核通过未测评、4测评完成但未标识、5标识完成)
let applyDB = [
  {
    'apply_id': '8098bb81e97f11e8a28a204747b14756',
    'company_id': 'ce92c1f4e97311e8a28a204747b14756',
    'apply_status': '1',
    'industry_id': '',
    'service_id': '05e10c8fe97711e8a28a204747b14756',
    'apply_date': '16/11/2018 17:10:46',
    'audited_date': '',
    'assess_date': '',
    'security_grade': '',
    'security_assess_grade': '',
    'identify_date': '',
    'identify_url': '',
    'apply_flag': '0'
  },
  {
    'apply_id': '81a8dc06e97f11e8a28a204747b14756',
    'company_id': 'ce92c1f4e97311e8a28a204747b14756',
    'apply_status': '1',
    'industry_id': '',
    'service_id': '0647962be97711e8a28a204747b14756',
    'apply_date': '16/11/2018 17:10:48',
    'audited_date': '',
    'assess_date': '',
    'security_grade': '',
    'security_assess_grade': '',
    'identify_date': '',
    'identify_url': '',
    'apply_flag': '1'
  },
  {
    'apply_id': '8213a307e97f11e8a28a204747b14756',
    'company_id': 'ce92c1f4e97311e8a28a204747b14756',
    'apply_status': '1',
    'industry_id': '',
    'service_id': '07282c06e97711e8a28a204747b14756',
    'apply_date': '16/11/2018 17:10:48',
    'audited_date': '',
    'assess_date': '',
    'security_grade': '',
    'security_assess_grade': '',
    'identify_date': '',
    'identify_url': '',
    'apply_flag': '0'
  },
  {
    'apply_id': '82d0d249e97f11e8a28a204747b14756',
    'company_id': 'ce92c1f4e97311e8a28a204747b14756',
    'apply_status': '1',
    'industry_id': '',
    'service_id': 'cbabedc0e97611e8a28a204747b14756',
    'apply_date': '16/11/2018 17:10:49',
    'audited_date': '',
    'assess_date': '',
    'security_grade': '',
    'security_assess_grade': '',
    'identify_date': '',
    'identify_url': '',
    'apply_flag': '0'
  },
  {
    'apply_id': '830077a1e97f11e8a28a204747b14756',
    'company_id': 'ce92c1f4e97311e8a28a204747b14756',
    'apply_status': '3',
    'industry_id': '',
    'service_id': '07282c06e97711e8a28a204747b14756',
    'apply_date': '16/11/2018 17:10:50',
    'audited_date': '',
    'assess_date': '',
    'security_grade': '',
    'security_assess_grade': '',
    'identify_date': '',
    'identify_url': '',
    'apply_flag': '1'
  },
  {
    'apply_id': '832d930ee97f11e8a28a204747b14756',
    'company_id': 'ce92c1f4e97311e8a28a204747b14756',
    'apply_status': '1',
    'industry_id': '',
    'service_id': '06836758e97711e8a28a204747b14756',
    'apply_date': '16/11/2018 17:10:50',
    'audited_date': '',
    'assess_date': '',
    'security_grade': '',
    'security_assess_grade': '',
    'identify_date': '',
    'identify_url': '',
    'apply_flag': '1'
  },
  {
    'apply_id': '83584d7ee97f11e8a28a204747b14756',
    'company_id': 'ce92c1f4e97311e8a28a204747b14756',
    'apply_status': '3',
    'industry_id': '',
    'service_id': '05e10c8fe97711e8a28a204747b14756',
    'apply_date': '16/11/2018 17:10:50',
    'audited_date': '',
    'assess_date': '',
    'security_grade': '',
    'security_assess_grade': '',
    'identify_date': '',
    'identify_url': '',
    'apply_flag': '1'
  },
  {
    'apply_id': '837e3904e97f11e8a28a204747b14756',
    'company_id': 'ce92c1f4e97311e8a28a204747b14756',
    'apply_status': '3',
    'industry_id': '',
    'service_id': '4a30d019e97811e8a28a204747b14756',
    'apply_date': '16/11/2018 17:10:51',
    'audited_date': '',
    'assess_date': '',
    'security_grade': '',
    'security_assess_grade': '',
    'identify_date': '',
    'identify_url': '',
    'apply_flag': '1'
  },
  {
    'apply_id': '83a7d2c0e97f11e8a28a204747b14756',
    'company_id': 'ce92c1f4e97311e8a28a204747b14756',
    'apply_status': '3',
    'industry_id': '',
    'service_id': 'cbabedc0e97611e8a28a204747b14756',
    'apply_date': '16/11/2018 17:10:51',
    'audited_date': '',
    'assess_date': '',
    'security_grade': '',
    'security_assess_grade': '',
    'identify_date': '',
    'identify_url': '',
    'apply_flag': '1'
  },
  {
    'apply_id': '83d26c7ee97f11e8a28a204747b14756',
    'company_id': 'ce92c1f4e97311e8a28a204747b14756',
    'apply_status': '1',
    'industry_id': '',
    'service_id': '4a30d019e97811e8a28a204747b14756',
    'apply_date': '16/11/2018 17:10:51',
    'audited_date': '',
    'assess_date': '',
    'security_grade': '',
    'security_assess_grade': '',
    'identify_date': '',
    'identify_url': '',
    'apply_flag': '0'
  }
]

export { applyDB }
